<script lang="ts">
    import BaseNode from "../BaseNode.svelte";
    import BaseNodeRect from "../BaseNodeRect.svelte";
    import { moveMachineState, node_delete } from "../actions/machineState";
    import { addTransitionMealy_add, transitionExists } from "../actions/transition";
    import { setAddTransitionFromNodeId, select_node } from "../actions/ui";
    import type { MachineStateMealy } from "../state/machineState";
    import { EditMode } from "../state/uiState";
    import type { Node } from "../state/node";

    import { getUpdateMachineState } from './context';
    import type { Vector } from "../Vector";
    const updateMachineState = getUpdateMachineState();

    export let node: Node;
    export let machineState: MachineStateMealy;
    $: uiState = machineState.uiState;

    $: isHighlighted = (() => {
        if (uiState.editMode === 'EXECUTION') {
            return machineState.executionState.currentNode.id === node.id;
        } else {
            return uiState.selection.stateId === node.id
        }
    })();

    $: fill = isHighlighted ? '#ffd9cc' : 'white';
    $: strokeWidth = isHighlighted ? '3' : '1';

    function handleClick() {
        console.log('handleClick')
        if (uiState.editMode === EditMode.ADD_TRANSITION) {
            if (typeof uiState.addTransition.fromNodeId === 'string') {
                // es wurde bereits vorher ein Startzustand gewählt
                if (transitionExists(machineState.machine.transitions, uiState.addTransition.fromNodeId, node.id)) {
                    // console.log('Transition existiert bereits')
                    return;
                }
                const newMachineState = addTransitionMealy_add(machineState, uiState.addTransition.fromNodeId, node.id);
                updateMachineState(newMachineState);
            } else {
                // Startzustand wählen
                const newMachineState = setAddTransitionFromNodeId(machineState, node.id);
                updateMachineState(newMachineState);
            }
        } else if (uiState.editMode === EditMode.NEUTRAL) {
            const newMachineState = select_node(machineState, node.id);
            updateMachineState(newMachineState);
        } else if (uiState.editMode === EditMode.DELETE) {
            const newMachineState = node_delete(machineState, node.id);
            updateMachineState(newMachineState);
        }
    }

    function handleMove(position: Vector) {
        const newMachineState = moveMachineState(machineState, node.id, position);
        updateMachineState(newMachineState);
    }
</script>

<!-- <BaseNode 
    node={node}
    machineState={machineState}
    fill={fill}
    onClick={handleClick}
    updateMachineState={updateMachineState}
/> -->

<BaseNode
    node={node}
    onMove={handleMove}
    fill={fill}
    strokeWidth={strokeWidth}
    onClick={handleClick}
    enableDrag={uiState.editMode === EditMode.NEUTRAL}
/>